var React = require('react');

function ConsumerTriangleSales (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M97.4862 90.8903L154.117 25.4222L185.312 155.993L97.4862 90.8903Z","fill":"#6C21E4","key":0}),React.createElement("path",{"d":"M9.0194 73.5806L154.268 25.4505L97.6732 90.8111L9.0194 73.5806Z","fill":"#651DD8","key":1}),React.createElement("path",{"d":"M9.03125 73.5879L97.6226 90.8062L185.324 156L9.03125 73.5879Z","fill":"#5915C7","key":2})]);
}

ConsumerTriangleSales.defaultProps = {"width":"209","height":"156","viewBox":"0 0 209 156","fill":"none"};

module.exports = ConsumerTriangleSales;

ConsumerTriangleSales.default = ConsumerTriangleSales;
